import React from 'react'

interface Props {
  data: Record<string, unknown> | Array<Record<string, unknown>>
}

const JsonLd: React.FC<Props> = ({ data }) => (
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
)

export default JsonLd
